import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import { TEXTOS } from 'v2/pages/GestaoDeUsuarios/frases'
import { ErroDeAcesso, gestaoDeUsuarios } from 'v2/pages/GestaoDeUsuarios/gestao-de-usuarios.service'

export const BalancoDoDia = ({ aberto, onFechar }: { aberto: boolean; onFechar: () => void }) => {
  const { openAlert } = useAlert()
  const { user } = useAuth()
  const queryClient = useQueryClient()
  const { data, isError } = useQuery({
    queryKey: ['acesso', 'eu', 'balanco', user?.id],
    queryFn: gestaoDeUsuarios.meuBalanco,
    enabled: aberto,
    retry: false,
    staleTime: 5 * 60_000,
  })

  const { mutate, isPending } = useMutation({
    mutationFn: (novo: boolean) => gestaoDeUsuarios.mudarMeuBalanco(novo),
    onSuccess: (_, novo) => {
      openAlert(novo ? TEXTOS.MEU_BALANCO_LIGADO : TEXTOS.MEU_BALANCO_DESLIGADO, 'success')
      queryClient.invalidateQueries({ queryKey: ['acesso'] })
    },
    onError: (erro) => openAlert(erro instanceof ErroDeAcesso ? erro.message : TEXTOS.ERRO_AO_SALVAR, 'error'),
  })

  return (
    <Dialog open={aberto} onClose={onFechar} fullWidth maxWidth='xs'>
      <DialogTitle>{TEXTOS.BALANCO_DO_DIA}</DialogTitle>
      <DialogContent>
        <FormControlLabel
          label='Receber o Balanço do dia'
          control={
            <Switch
              checked={!!data?.recebe}
              disabled={!data || isPending}
              onChange={() => data && mutate(!data.recebe)}
            />
          }
        />
        {isError && (
          <Typography variant='caption' color='error' display='block'>
            {TEXTOS.ERRO_AO_CARREGAR}
          </Typography>
        )}
        {data?.recebe && data.motivoSemEnvio && (
          <Typography variant='caption' display='block'>
            {TEXTOS.LIGADO_SEM_ENVIO(TEXTOS.MOTIVO[data.motivoSemEnvio])}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar}>Fechar</Button>
      </DialogActions>
    </Dialog>
  )
}
